import React, { ChangeEvent, ReactNode, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import {
  Textarea,
  InlineMenu,
  ErrorModal,
  SectionSubtitle,
  BackButton,
  Button,
} from '../../components'
import FormHeader from '../../components/forms/formHeader/FormHeader'
import { useStudents, useUser } from '../../context'

import {
  ContainerInitialForm,
  DescritpionContainer,
  Form,
  FormContainer,
  InitialFormContent,
  QuestionWithAnswers,
} from './styles'

export const questions = [
  {
    id: '1',
    text: 'Por favor, indica cuáles han sido tus experiencias previas de trabajo vocal. (Profesores, técnicas o metodologías, duración, etc).',
    type: 'textarea',
  },
  {
    id: '2',
    text: 'Podrías resumir en algunas frases qué es lo que sientes que has obtenido como resultado de esos entrenamientos?',
    type: 'textarea',
  },
  {
    id: '3',
    text: '¿Hay algo que hayas alcanzado a descubrir pero no has llegado a entrenar, comprender en profundidad o asegurar?',
    type: 'textarea',
  },
  {
    id: '4',
    text: '¿Cuánto crees que conoces de tu instrumento vocal?',
    type: 'menu',
    menuName: 'knowInstrumentOptions',
  },
  {
    id: '5',
    text: '¿A que nivel de dominio/control vocal sientes que estas?',
    type: 'menu',
    menuName: 'experticeMenuStudent',
  },
  {
    id: '6',
    text: 'En la actualidad, ¿cuánto tiempo le dedicas al entrenamiento/desarrollo de tu Voz?',
    type: 'menu',
    menuName: 'dedicationTime',
  },
  {
    id: '7',
    text: '¿Cuanto tiempo estas dispuest@ a invertir en la repetición de ejercicios, pautas y tablas de entreno? (Trabajo en casa)',
    type: 'menu',
    menuName: 'dedicationTime',
  },
]

const InitialForm = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const userId = location.state?.userId
  const { user } = useUser()
  const { saveFormAnswers } = useStudents()
  const [message, setMessage] = useState<string | null | ReactNode>(null)
  const [confirmationModal, setConfirmationModal] = useState(false)

  const sendForm = async () => {
    try {
      await saveFormAnswers(userId, formAnswers)
      setMessage('Formulario guardado correctamente')
    } catch (error) {
      setMessage(error as string)
    } finally {
      setConfirmationModal(true)
    }
  }

  const [formAnswers, setFormAnswers] = useState<Record<string, string>>({})

  const handleChangeAnswers = (number: string, value: string) => {
    setFormAnswers((prev) => ({ ...prev, [number]: value }))
  }

  const isFormIncomplete = !['1', '2', '3', '4', '5', '6', '7'].every(
    (id) => formAnswers[id] && formAnswers[id].trim() !== '',
  )

  const goBack = () => {
    navigate(-1)
  }

  return (
    <ContainerInitialForm>
      {!user && <FormHeader />}
      {confirmationModal && message && (
        <ErrorModal
          errorMessage={message}
          setOpenModal={setConfirmationModal}
          setError={setMessage}
        />
      )}

      <InitialFormContent $isLogged={user ? true : false}>
        <BackButton goBack={goBack} />
        <DescritpionContainer>
          <p className="description">
            Hola-ah! Para empezar a conocernos, aquí te presentamos un
            cuestionario inicial que nos servirá de guía para fijar un buen
            punto de partida en el entrenamiento que nuestro equipo Diga-ah
            creará para ti.
            <br />
            <br />
            Te recomendamos que te tomes un tiempo para responder este
            cuestionario con atención y conciencia, ya que cuanto más profundo
            te sumerjas con tus respuestas, mayor provecho obtendremos de la
            información que compartas en este formulario.No te preocupes si
            alguna pregunta te genera confusión; simplemente continúa y luego
            analizaremos tus respuestas juntos.
          </p>
        </DescritpionContainer>
        <FormContainer>
          <Form>
            <SectionSubtitle
              children="Responde las siguientes 7 consignas:"
              textAlign="left"
              fontSize={18}
              fontWeight={500}
              lineHeight={25}
              className="initial-form-title"
            />

            {questions.map(({ id, text, type, menuName }) => (
              <QuestionWithAnswers key={id}>
                <p className="number">{id}</p>
                <p className="question">{text}</p>
                <div className="textarea-answer">
                  {type === 'textarea' ? (
                    <Textarea
                      id={`question-${id}`}
                      name={id}
                      value={formAnswers[id] || ''}
                      height={70}
                      onChange={(event: ChangeEvent<HTMLTextAreaElement>) =>
                        handleChangeAnswers(id, event.target.value)
                      }
                    />
                  ) : (
                    <InlineMenu
                      userType="student"
                      menuName={menuName || ''}
                      activeFilter={formAnswers[id] || null}
                      setActiveFilter={(value) =>
                        handleChangeAnswers(id, value as string)
                      }
                      isDisabled={false}
                    />
                  )}
                </div>
              </QuestionWithAnswers>
            ))}

            <SectionSubtitle
              fontSize={18}
              fontWeight={500}
              children="¡Gracias por llegas hasta aquí!"
            />

            <Button
              onClick={() => sendForm()}
              label="Guardar respuesta"
              className="dark-grey button-save"
              disabled={isFormIncomplete}
            />
          </Form>
        </FormContainer>
      </InitialFormContent>
    </ContainerInitialForm>
  )
}

export default InitialForm
